import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { PopoverPosition } from 'modules/core/components/DateNavigator/_Popover'
import { FixedDuration } from 'modules/core/components/DateNavigator/constants'
import { Cycle } from 'modules/core/components/DateNavigator/cycleUtils'
import { useUnsafeCallback } from 'modules/core/hooks/useCallback'

import { PickerSelector } from '../_PickerSelector'
import { Shortcuts } from '../_Shortcuts'

type Props = {
  regularPeriods?: FixedDuration[]

  cycle?: Cycle
  startDate: Date
  endDate: Date
  onDateRangeChange: (startDate: Date, endDate: Date) => void
  setPopoverPosition: (position: PopoverPosition) => void
}

export const DateRangeSelectorBody = ({
  regularPeriods,
  cycle,
  startDate,
  endDate,
  onDateRangeChange,
  setPopoverPosition,
}: Props) => {
  const [customRangeSelected, setCustomRangeSelected] = useState(false)

  const handleCustomRangeClick = useUnsafeCallback(() => {
    setCustomRangeSelected(true)

    setPopoverPosition({
      attachment: 'top center',
      targetAttachment: 'bottom center',
    })
  }, [])

  const renderShortcuts = (showCustomOption: boolean) => {
    return (
      <Shortcuts
        regularPeriods={regularPeriods}
        cycle={cycle}
        startDate={startDate}
        endDate={endDate}
        showCustomOption={showCustomOption}
        onDateRangeChange={onDateRangeChange}
        onCustomSelected={handleCustomRangeClick}
      />
    )
  }

  const renderPicker = () => {
    return (
      <PickerSelector
        regularPeriods={regularPeriods}
        startDate={startDate}
        endDate={endDate}
        onDateRangeChange={onDateRangeChange}
      />
    )
  }

  const showInlineShortcuts = !regularPeriods
  const singleRegularPeriodAvailable = regularPeriods && regularPeriods.length === 1
  const showShortcuts = !customRangeSelected && !singleRegularPeriodAvailable

  if (showInlineShortcuts) {
    return (
      <Box flexDirection="row">
        <Box border={{ right: { width: 's1', color: 'grey400', style: 'solid' } }}>
          {renderShortcuts(false)}
        </Box>
        {renderPicker()}
      </Box>
    )
  }

  if (showShortcuts) {
    return renderShortcuts(true)
  }

  return renderPicker()
}
